import { gsap, ScrollTrigger } from "@gsap";
/**
 * Layout: Vacature overzicht
 * Slug: vacature_overview
 */

document.addEventListener('DOMContentLoaded', function() {
    gsap.registerPlugin(ScrollTrigger);
    const layouts = document.querySelectorAll('.flex-layout.vacature_overview-layout');

	layouts.forEach((layout) => {
		const form = layout.querySelector('#filterForm');
		const resultsContainer = layout.querySelector('#vacature-results');
		if (!form || !resultsContainer) return;

		function animateCards() {
			gsap.from(resultsContainer.children, {
				y: -20,
				opacity: 0,
				stagger: 0.1,
				scrollTrigger: {
					trigger: resultsContainer,
				},
			});
		}

		animateCards();

		const ajaxUrl = form.dataset.ajaxUrl;
		const nonce = form.dataset.nonce;
		const filterSelects = form.querySelectorAll('select[data-filter]');

		// Tracks the in-flight request so a fast second filter change cancels
		// the stale one instead of racing it.
		let activeRequest = null;

		function updateUrl(params) {
			const url = new URL(window.location.href);
			Object.entries(params).forEach(([key, value]) => {
				value ? url.searchParams.set(key, value) : url.searchParams.delete(key);
			});
			// replaceState (not pushState): filter changes shouldn't clutter
			// the back-button history, just the current URL.
			window.history.replaceState(window.history.state, '', url);
		}

		function applyFilters() {
			const params = {};
			filterSelects.forEach((select) => {
				params[select.dataset.filter] = select.value;
			});

			if (activeRequest) {
				activeRequest.abort();
			}
			const controller = new AbortController();
			activeRequest = controller;

			layout.classList.add('is-loading');

			fetch(ajaxUrl, {
				method: 'POST',
				body: new URLSearchParams({ action: 'vacature_filter', nonce, ...params }),
				signal: controller.signal,
			})
				.then((response) => response.json())
				.then((data) => {
					if (!data?.success) return;
					resultsContainer.innerHTML = data.data.html;
					animateCards();
					updateUrl(params);
				})
				.catch((error) => {
					if (error.name !== 'AbortError') {
						console.error('Vacature filter request failed:', error);
					}
				})
				.finally(() => {
					if (activeRequest === controller) {
						layout.classList.remove('is-loading');
						activeRequest = null;
					}
				});
		}

		filterSelects.forEach((select) => select.addEventListener('change', applyFilters));
	});
});
